<template>
	<v-header title="首页" :headerLeftStatus="false" />
	<div class='sysMain'>
		<div class="swiper">
				<Carousel autoplay loop :autoplay-speed="4000">
					<CarouselItem v-for="item in view.carouselImg">
						<!-- <img :src="require('../../static/wwwroot/Carouses/'+item)" /> -->
						<img :src="view.server+'Files/Img/'+item" />
					</CarouselItem>
				</Carousel>
			</div>
			<div class="icon">
				<ul class='icon-ul'>
					<li class='icon-li'>
						<Row class="ivu-text-center"
							@click="goInternet(view.introductionUrl)">
							<Col flex="1">
							<img :src="require('../../static/img/keshi.png')"
								style="width: 35px;height: 35px;margin-left: 10px;" />
							<Paragraph class="ivu-mt-8">健康管理</Paragraph>
							</Col>
						</Row>
					</li>
					<li class='icon-li'>
						<Row class="ivu-text-center" @click="gorouter('/patient')">
							<Col flex="1">
							<img :src="require('../../static/img/family.png')"
								style="width: 35px;height: 35px;margin-left: 10px;" />
							<Paragraph class="ivu-mt-8">体检报告</Paragraph>
							</Col>
						</Row>
					</li>
					<li class='icon-li'>
						<Row class="ivu-text-center" @click="gorouter('/contactus')">
							<Col flex="1">
							<img :src="require('../../static/img/contactus.png')"
								style="width: 35px;height: 35px;margin-left: 10px;" />
							<Paragraph class="ivu-mt-8">联系我们</Paragraph>
							</Col>
						</Row>
					</li>
				</ul>
			</div>
			<Grid :col="2" padding="15px">
				<GridItem v-show="view.disabledRegister===false">
					<Row>
						<Col span="8" class="ivu-pt-8">
						<Icon type="md-clock" size="30" color="rgba(255, 197, 72)" />
						</Col>
						<Col span="16" @click="gorouter('/registerIndex')">
						<p> <Text strong>登记预约</Text></p>
						<p> <Text type="secondary" class="font12">登记预约</Text></p>
						</Col>
					</Row>
				</GridItem> 
				<GridItem v-show="view.disabledQueue===false">
					<Row>
						<Col span="8" class="ivu-pt-8">
						<Icon type="md-calendar" size="30" color="rgba(15, 184, 132)" />
						</Col>
						<Col span="16" @click="gorouter('/myYuYue')">
						<p> <Text strong>体检预约</Text></p>
						<p> <Text type="secondary" class="font12">体检进度</Text></p>
						</Col>
					</Row>
				</GridItem>
				<GridItem>
					<Row>
						<Col span="8" class="ivu-pt-8">
						<Icon type="md-paper" size="30" color="rgba(208, 32, 144)" />
						</Col>
						<Col span="16" @click="gorouter('/suite')">
						<p> <Text strong>体检套餐</Text></p>
						<p> <Text type="secondary" class="font12">一对一定制</Text></p>
						</Col>
					</Row>
				</GridItem>
				<GridItem v-show="view.disabledPay===false">
					<Row>
						<Col span="8" class="ivu-pt-8">
						<Icon type="md-person" size="30" color="rgba(255, 197, 72)" />
						</Col>
						<Col span="16" @click="gorouter('/center')">
						<p> <Text strong>个人中心</Text></p>
						<p> <Text type="secondary" class="font12">个人信息</Text></p>
						</Col>
					</Row>
				</GridItem>
			</Grid>
			<div class="news" v-if="view.disabledNews===false">
				<Tabs>
					<TabPane :label="itemtype.infoTypeName" v-for="itemtype in view.newsList" :key="itemtype.infoType">
						<div class="news_Main">
							<div v-for="item in itemtype.newsList" :key="item.title" class="news_List">
								<div class="news_title" @click="newsDetail(item.organizeInfo)">
									{{item.infoTitle}}
								</div>
								<div class="news_desc">
									<span>{{item.authorName}}</span>
									<span>{{converterEx.toDateString(item.publishTime)}}</span>
								</div>
							</div>
						</div>
					</TabPane>
				</Tabs>
			</div>
		
	</div>
	<v-footer />
</template>

<script>
	import header from "@/components/header/index";
	import footer from "@/components/footer/index";
	import {
		sysPost
	} from '@/utils/api'
	import {
		getToken
	} from '@/utils/auth'
	export default {
		name: 'index',
		data() {
			return {
				view: {
					server:process.env.VUE_APP_Server,
					newsList: [],
					disabledPay: false,
					shortTitle: "",
					carouselImg: [],
					introductionUrl: "",
					disabledNews:false,
					disabledRegister:false,
					disabledQueue:false,
				}

			};
		},
		mounted() {
			var token = getToken();
			if (token) {
				this.view.disabledPay = token.viewDisabledPay;
				this.view.shortTitle = token.viewShortTitle;
				this.view.carouselImg = token.viewCarouselImg.split(',');
				this.view.introductionUrl = token.viewIntroductionUrl;
				this.view.introductionUrl = token.viewIntroductionUrl;
				this.view.disabledNews = token.viewDisabledNews;
				this.view.disabledRegister=token.viewDisabledRegister;
				this.view.disabledQueue=token.viewDisabledQueue;
				if(this.view.disabledNews==false)this.init();
			}
		},
		methods: {
			init() {
				var that = this;
				//新闻
				sysPost(that, {
					"url": 'WX/GetHomeNewsList',
					"data": {
						"ClientSign": "News",
						"NewsSize": 4
					}
				}, function(result) {
					that.view.newsList = result;
				});
			},
			goInternet(url) {
				window.location.href = url
			},
			gorouter(name) {
				this.$router.push(name)
			},
			newsDetail(id) {
				this.$router.push({
					path: "/newsInfo",
					query: {
						Id: id
					}
				})
			},
		},
		components: {
			"v-header": header,
			"v-footer": footer
		},
	}
</script>

<style lang="less" scoped>
	.swiper {
		height: 3.9rem;

		img {
			width: 100%;
			height: 3.9rem;
		}
	}

	.icon {
		width: 100%;
		height: 2rem;
		background: white;
		border-bottom: 1px solid #f4f4f4;

		.icon-ul {
			width: 100%;
			height: 100%;
			padding-top: 20px;

			.icon-li {
				width: 33.3%;
				height: 100%;
				float: left;
				margin: auto;

				a {
					width: 100%;
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;

					img {
						display: block;
						width: 70%;
					}
				}
			}
		}
	}

	.news {
		margin: 10px;
	}
	.news_Main {
		height: 230px;
		overflow: auto;
	}

	.news_List {
		height: 1.1rem;
		border-bottom: 1px solid #f4f4f4;

	}

	.news_title {
		font-size: 0.30rem;
		margin-top: 10px;
		font-weight: bold;
	}

	.news_desc {
		span {
			margin-right: 10px;
			font-size: 12px;
		}
	}

</style>
